export const authorBaseUrl = process.env.NEXT_PUBLIC_AUTHORBASEURL
export const publisherBaseUrl = process.env.NEXT_PUBLIC_PUBLISHERBASEURL
export const baseUrl = process.env.NEXT_PUBLIC_BASEURL
export const dataUrl = "/en.model.json"
export const searchDataUrl = "/en/search.model.json"
export const cartDataUrl = authorBaseUrl + "/en/cart.model.json"
export const headerUrl =
  "/content/experience-fragments/mira-showers/gb/en/qa-testing-xf/mira-header/master"
export const footerUrl =
  "/content/experience-fragments/mira-showers/gb/en/qa-testing-xf/test_copy/Global-footer-experience-fragment1/master"
export const pageUrl = "/en/"
export const cartPage = pageUrl + "cart"
export const checkoutDataUrl = authorBaseUrl + "/en/checkout.model.json"
export const sharedCartUrl = authorBaseUrl + "/en/cart/shared-cart.model.json"
export const orderConfirmationDataUrl =
  authorBaseUrl + "/en/orders/order-confirmation.model.json"
export const orderDetailsPageDataUrl =
  authorBaseUrl + "/en/orders/order-details.model.json"
export const orderHistoryPageDataUrl =
  authorBaseUrl + "/en/orders/order-history.model.json"
export const orderStatusPageDataUrl =
  authorBaseUrl + "/en/orders/order-status.model.json"
export const PRODUCT_DATA_URL = `${authorBaseUrl}/en/products/product-details.model.json`
export const MyProductsPageDataUrl =
  authorBaseUrl + "/en/my-account/my-products.model.json"
export const loveYourLookDataURL =
  authorBaseUrl + "/en/love-your-look.model.json"
export const apiBaseUrl = process.env.NEXT_PUBLIC_APIBASEURL
export const oktaTokenEndpoint = "/oauth/token"
export const getCartEndPoint = "/cart/active?expand=calculation"
export const createCartEndPoint = "/cart/create"
export const getStockEndPoint = "/catalog/inventory"
export const cartItemsEndPoint = "/cart/v2/items"
export const shippingCostEndPoint = "/checkout/shipping-cost"
export const discountEndPoint = "cart/v2/discount?expand=calculation"
export const taxEndPoint = "/cart/v2/items?expand=calculation"
export const shareCartEndPoint = "/cart/sharedcart"
export const mergeCartEndPoint = "/cart/merge?expand=calculation"
export const signupEndPoint = "/customer/signup"
export const deleteCartEndPoint = "/cart/v2/deleteActiveCart"
export const shipmentFromCartEndPoint = "/checkout/v2/assign/shipmentfromcart"
export const addAddressEndPoint = "/customer/address"
export const addressSuggestionEndPoint = "/maps/address/validate"
export const validateTokenEndPoint = "/oauth/token/validate"
export const orderSubmitEndPoint = "/checkout/v2/order/submit"
export const paymentEndPoint = "/checkout/payment"
export const payPalPaymentEndPoint = "/payment/paypal/getToken"
export const recentlyViewedEndPoint = "/catalog/product/projection"
export const searchPlpEndPoint = "/search/plp"
export const searchProfilePlpEndPoint = "/search/profile"
export const checkSplitOrderEndPoint = "/checkout/order-split-check"
export const searchPdpEndPoint = "/search/pdp"
export const pdpCatalogProjectionEndPoint = "/catalog/product/projection"
export const getPdpTooltipEndPoint = "/search/tooltip"
export const accountSettingsPageDataUrl =
  authorBaseUrl + "/en/my-account/account-settings.model.json"
export const myProductsEndPoint =
  "/shopping-list/MyProducts?lang=" + process.env.NEXT_PUBLIC_LOCALE
export const fetchProductRegistrationEndPoint = "/crm/fetchproductregistration"
export const staticClasses = {
  CONTAINER: "container responsivegrid",
}
export const productBySkuEndPoint_compare = "/search/plp"
export const productBySkuEndPoint = "/catalog/product/projection"
export const MyServicePageDataUrl =
  authorBaseUrl + "/en/my-account/my-services.model.json"
export const MyFavoritesPageDataUrl = `${authorBaseUrl}/en/my-account/my-favorites.model.json`
export const REGISTER_OFFLINE_PRODUCTS_DATA_URL = `${authorBaseUrl}/en/my-account/product-registration/register-offline-product.model.json`
export const REGISTER_ONLINE_PRODUCTS_DATA_URL = `${authorBaseUrl}/en/my-account/product-registration/register-online-product.model.json`
export const CONSTANTS = {
  DEFAULT_IDLE_TIMEOUT: 172800, // In Seconds
  DEFAULT_VERSION: "v1",
  ERROR_CODES: {
    BAD_REQUEST_ERROR: 400,
    INTERNAL_SERVER_ERROR: 500,
    AUTHENTICATION_ERROR: [401, 403],
  },
  USER_STATE: {
    LOGGED_USER: "logged",
    ANONYMOUS_USER: "anonymous",
  },
  PARENT_COMPONENTS_LIST: {
    ORDER_DETAILS: "OrderDetails",
  },
  PAYMENT: {
    SUCCESS_CODE: "870",
    NUM_YEARS: 16,
  },
  ORDER_STATUS_SHIPPED: "Shipped",
  DELETE_INACTIVE_MYFOLDER_AFTER: 30,
  ERROR_MESSAGE: {
    GENERAL: "Something went wrong. Please try again...",
    SESSION_TIMEOUT_MSG: "Your session is expired.. Please login again...",
    SESSION_TIMEOUT_SECURE_PAGE_MSG:
      "Redirecting to Home Page due to inactivity",
  },
  COLOR_FILE_URL: "https://kohler.scene7.com/is/image/PAWEB/", // TODO: Obtain value from config
  CT_API_URL: "https://api.us-central1.gcp.commercetools.com", // TODO: Obtain value from config
  CT_PROJECT_KEY: "kohler-na-qa-1", // TODO: Obtain value from config
  CT_SALES_CHANNEL: "KOUS", // TODO: Obtain value from config
  REGEX_TEXT: /^[a-z\d\-,'"\s]+$/,
  REGEX_ALPHANUMERIC_SAFE_CHARS: /^[a-z\d\-,'"\s]+$/i,
  REGEX_PASSWORD: new RegExp(
    "^(?=.*[a-z])(?=.*[A-Z])(?=.*[0-9])(?=.*[!@#$%^&*])(?=.{11,})"
  ),
  REGEX_EMAIL:
    /^((?!\.)(?!\-)(?!\_)[a-z0-9]*([\.\-\_]?[a-z0-9\-]*)?[^\-`_.#()+/=!@$%^&*:'"<>])(@(?!\.)(?!\-)(?!\_)[\w-]+)(\.\w+(\.\w+)?[^.\W])$/i,
  KEYCODE: { ENTER: 13, ESC: 27, SPACE: 32, UP: 38, DOWN: 40, TAB: 9 },
  KEY: { ENTER: "Enter", ESC: "Escape" },
  FF_PERSONA: "US_Kcom_FriendsNFamily:FF",
  KEMP_PERSONA: "US_Kcom_KohlerCoAssociate:KEMP",
  KF_FORCE_RENEW_TOKEN: "kf-okta-force-renew-token",
  KF_UPDATE_MEMBERSHIP: "kf-update-membership",
  CREATE_ACCOUNT_TYPE: {
    HOME_OWNER: "homeowner",
    PROFESSIONAL: "professional",
  },
  UNDEFINED: "undefined",
  COMPONENT: {
    PAIRS_WELL_WITH: "pairsWellWith",
  },
}
export const favoritesEndPoint =
  "/shopping-list/Favorites?lang=" + "en-US"           // Changed env variable to en-US for MCPT-1574
export const createFavoritesEndPoint = "/shopping-list/create"
export const addFavoritesEndPoint = id => {
  return `/shopping-list/add/${id}?type=product`
}
export const removeFavoritesEndPoint = id => {
  return `/shopping-list/remove/items/${id}`
}
export const SWATCH_NA = "swatch_NA"
export const ADD_10_MINUTES = 600000
export const DUOLOGI_MIN_AMOUNT = 350
export const DUOLOGI_MAX_AMOUNT = 15000
export const PRIVACY_COOKIE_CLICKED = "is_privacy_cookie_clicked"
export const GLOBAL_CONFIGURATION_PATH =
  "/bin/kohler/services/globalconfig.mira-showers.json"
export const DOMAIN = process.env.NEXT_PUBLIC_GLOBALCONFENV
export const GLOBAL_CONFIGURATION_ENDPOINT = DOMAIN + "/api/globalconfig"
export const locationIpEndPoint = "/maps/location/ip/"
export const locationZipEndPoint = "/maps/location/zipcode/"
export const STORE_MIN_DISTANCE = 64
export const STORE_MAX_DISTANCE = 1000
export const LOCATION_API_TRIGGER_INTERVAL = 1800000 // 30mins
export const STORE_DETAILS_API_ENDPOINT = DOMAIN + "/api/storedetails"
export const DEFAULT_STORE_DETAILS_API_PATH =
  "/bin/kohler/services/storedetails?path="
export const GET_PROFILE_ENDPOINT = "/customer/me"
export const ZIP_FILE_DOWNLOAD_ENDPOINT = "/catalog/zip-file-download"
export const SEARCH_PLP_ENDPOINT = "search/plp"
// cart Dicount
export const stopedByPreviousDiscount = "ApplicationStoppedByPreviousDiscount"
export const maxAppReached = "MaxApplicationReached"
export const emailSubscribeEndPoint = "/crm/newsletter/subscription"
export const TOAST_MESSAGE_DEFAULT_DURATION = 5000 // 5seconds
export const editAddressEndPoint = "customer/address"
export const FIND_MY_ORDERS_ENDPOINT = "/checkout/orders/query"
export const SPLIT_ORDER = "checkout/ordersplit"
export const GET_GUEST_TOKEN_ENDPOINT = DOMAIN + "/api/token"
// order confirmation
export const orderConstants = {
  COMPLETED: "Completed",
  CANCELLED: "Cancelled",
  CREDIT_CARD: "CREDIT_CARD",
  PAYPAL: "PP",
  SHIPPED: "Shipped",
}
export const GET_ORDER_DETAILS_ENDPOINT = "checkout/orders"
export const DEFAULT_CARD_DETAILS_API_PATH =
  "/bin/kohler/services/list?path=/content/kohler"
export const MY_SERVICES_ENDPOINT =
  "/shopping-list/MyServices?lang=" + process.env.NEXT_PUBLIC_LOCALE
export const MY_FAVORITES_ENDPOINT =
  "/shopping-list/Favorites?lang=" + process.env.NEXT_PUBLIC_LOCALE
export const COMPONENT_TYPES = {
  AEMFORM: "aemform",
  PRODUCTCARD: "productcard",
  CONTAINER: "container",
  VIDEO: "video",
  AUTH_MODAL: "authmodal",
  NEWSLETTER: "newsletter",
  TEASER: "teaser",
  CAROUSEL: "carousel",
  SLICK: "carousel-slick",
  SPACER: "spacer",
  TEXT: "text",
  TAB: "tab",
  BREADCRUMB: "breadcrumb",
  PRODUCTLIST: "productlist",
  SEARCH: "search/v1/search",
  EMBED: "embed",
  BRAND_SWITCHER: "brand-switcher",
  UTILITY_NAV_HEADER: "utilitynavheader",
  UTILITY_WIDGET: "utilitywidget",
  TABS: "tabs",
  IMAGE: "image",
  SITEWIDE_WARNING: "sitewide-warning",
  IMAGEV3: "image/v3/image",
  CAROUSELSLICK: "carousel-slick",
  TOASTER: "toaster/v1/toaster",
  COMPARE_PRODUCTS: "compareproducts",
  MAIN_FOOTER: "mainfooter",
  ADDITIONAL_FOOTER: "additionalfooter",
  NEWSLETTER_SIGNIN: "newslettersignin",
  NEWSLETTER_SIGNUP: "newslettersignup",
  CART_LANDING: "cart-landing",
  CHECKOUT: "checkout",
  ORDER_CONFIRMATION: "orderconfirmation",
  ORDER_STATUS: "orderstatus",
  ORDER_HISTORY: "orderhistory",
  ORDER_DETAILS: "orderdetails",
  SHARED_CART: "sharedcart",
  PAIRS_WELL_WITH: "pairs-well-with",
  HELPSUPPORT: "help-support",
  GLOBAL_NAVIGATION: "globalnavigation",
  PROMOBANNER: "plp-promo-banner",
  ACCOUNT_SETTINGS: "accountsettings",
  MY_SERVICES: "myservices",
  MY_FAVORITES: "myfavorites",
  MY_PRODUCTS: "myproducts",
  PRODUCT_DETAILS: "pdp/v1/pdp",
  PRODUCT_DETAILS_ACCORDION: "accordion",
  PRODUCT_DETAILS_EXFPDP: "exfpdp/v1/exfpdp",
  PRODUCT_DETAILS_REVIEW: "components/review",
  REGISTER_OFFLINE_PRODUCTS: "register-offline-products",
  REGISTER_ONLINE_PRODUCTS: "register-online-products",
}
export const FRAGMENT_TYPES = {
  HEADER: "header",
  MAIN: "main",
  FOOTER: "footer",
}
export const VIDEO_EVENTS = {
  PLAY: "play",
  PAUSE: "pause",
  ENDED: "ended",
}
export const TAB_WIDTH = 768
export const DESKTOP_WIDTH = 1280
export const ROW_COLUMN_MIN_WIDTH = 1025
// PLP
// sort constants
export const KEYCODE = {
  ENTER: 13,
  ESC: 27,
  SPACE: 32,
  UP: 38,
  DOWN: 40,
  TAB: 9,
}
// Filter
export const queryParamsToPersist = ["sort", "keyword", "tab"]
export const DEFAULT_NEWELETTER_POPUP_TRIGGER_TIME = 9
export const PLP_END_POINT = "/apirequest/search/v1/plp"
export const PLP_END_POINT_SUBSCRIPTION_KEY = "/apirequest/lw/plp"
export const PDP_END_POINT_SUBSCRIPTION_KEY = "/apirequest/lw/pdp/product"
export const apimSubscriptionKey = process.env.APIM_SUBSCRIPTION_KEY
export const PLP_END_POINT_CLIENT = "/search/v1/plp"
export const DEFAULT_PRODUCT_COUNT_PLP = 30
export const PROFILE_END_POINT_CLIENT = "/search/v1/profile"
export const debounceThresholdCheckUserExists = 500
export const customActivityEvents = ["click", "keydown"]
export const PAGE_TYPES = {
  CATEGORY_LANDING_PAGE: "category landing page",
}
export const PRODUCTS_PER_PAGE = [30, 60, 90]
export const imgPlaceholderData =
  "data:image/gif;base64,R0lGODlhAQABAIAAAAAAAP///yH5BAEAAAAALAAAAAABAAEAAAIBRAA7"
// Account Settings constants
export const EDIT_PROFILE_ENDPOINT = "/customer/profile"
export const DELETE_ACCOUNT_ENDPOINT = "/customer/account"
export const CHANGE_ACCOUNT_PASSWORD_ENDPOINT = "/customer/change_password"
export const TABS_NOT_REQUIRED_GRIDICON = [
  "inspiration",
  "technical",
  "resources",
  "help",
]
// myProducts endPoints
export const MY_PRODUCT_SEARCH_CATALOG = "/search/full-catalog"
export const MY_PRODUCT_PRODUCT_REGISTRATION = "/crm/product/registration"
export const PDP_TEASER_DETAILS = DOMAIN + "/api/pdpTeaserDetails"
export const FAILURE_TEXT = "failure"
export const SUCCESS_TEXT = "success"
export const EMAIL_ALREADY_EXIST = "Email address already subscribed"
export const MY_ACCOUNT = "My Account"
export const LOGIN = "Login"
export const SEARCH_ICON =
  "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTgiIGhlaWdodD0iMTgiIHZpZXdCb3g9IjAgMCAxOCAxOCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHBhdGggZmlsbC1ydWxlPSJldmVub2RkIiBjbGlwLXJ1bGU9ImV2ZW5vZGQiIGQ9Ik03LjY1IDEuOEM0LjQxOTEzIDEuOCAxLjggNC40MTkxMyAxLjggNy42NUMxLjggMTAuODgwOSA0LjQxOTEzIDEzLjUgNy42NSAxMy41QzkuMjY1NjggMTMuNSAxMC43MjY5IDEyLjg0NjIgMTEuNzg2NiAxMS43ODY2QzEyLjg0NjIgMTAuNzI2OSAxMy41IDkuMjY1NjggMTMuNSA3LjY1QzEzLjUgNC40MTkxMyAxMC44ODA5IDEuOCA3LjY1IDEuOFpNMCA3LjY1QzAgMy40MjUwMiAzLjQyNTAyIDAgNy42NSAwQzExLjg3NSAwIDE1LjMgMy40MjUwMiAxNS4zIDcuNjVDMTUuMyA5LjQzNzgxIDE0LjY4NTkgMTEuMDgzNCAxMy42NTg0IDEyLjM4NTZMMTcuNzM2NCAxNi40NjM2QzE4LjA4NzkgMTYuODE1MSAxOC4wODc5IDE3LjM4NDkgMTcuNzM2NCAxNy43MzY0QzE3LjM4NDkgMTguMDg3OSAxNi44MTUxIDE4LjA4NzkgMTYuNDYzNiAxNy43MzY0TDEyLjM4NTYgMTMuNjU4NEMxMS4wODM0IDE0LjY4NTkgOS40Mzc4MSAxNS4zIDcuNjUgMTUuM0MzLjQyNTAyIDE1LjMgMCAxMS44NzUgMCA3LjY1WiIgZmlsbD0iYmxhY2siLz4KPC9zdmc+Cg=="
export const CLOSE_ICON =
  "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjAiIGhlaWdodD0iMjAiIHZpZXdCb3g9IjAgMCAyMCAyMCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHBhdGggZmlsbC1ydWxlPSJldmVub2RkIiBjbGlwLXJ1bGU9ImV2ZW5vZGQiIGQ9Ik0wLjI5Mjg5MyAwLjI5Mjg5M0MwLjY4MzQxNyAtMC4wOTc2MzExIDEuMzE2NTggLTAuMDk3NjMxMSAxLjcwNzExIDAuMjkyODkzTDEwIDguNTg1NzlMMTguMjkyOSAwLjI5Mjg5M0MxOC42ODM0IC0wLjA5NzYzMTEgMTkuMzE2NiAtMC4wOTc2MzExIDE5LjcwNzEgMC4yOTI4OTNDMjAuMDk3NiAwLjY4MzQxNyAyMC4wOTc2IDEuMzE2NTggMTkuNzA3MSAxLjcwNzExTDExLjQxNDIgMTBMMTkuNzA3MSAxOC4yOTI5QzIwLjA5NzYgMTguNjgzNCAyMC4wOTc2IDE5LjMxNjYgMTkuNzA3MSAxOS43MDcxQzE5LjMxNjYgMjAuMDk3NiAxOC42ODM0IDIwLjA5NzYgMTguMjkyOSAxOS43MDcxTDEwIDExLjQxNDJMMS43MDcxMSAxOS43MDcxQzEuMzE2NTggMjAuMDk3NiAwLjY4MzQxNyAyMC4wOTc2IDAuMjkyODkzIDE5LjcwNzFDLTAuMDk3NjMxMSAxOS4zMTY2IC0wLjA5NzYzMTEgMTguNjgzNCAwLjI5Mjg5MyAxOC4yOTI5TDguNTg1NzkgMTBMMC4yOTI4OTMgMS43MDcxMUMtMC4wOTc2MzExIDEuMzE2NTggLTAuMDk3NjMxMSAwLjY4MzQxNyAwLjI5Mjg5MyAwLjI5Mjg5M1oiIGZpbGw9ImJsYWNrIi8+Cjwvc3ZnPgo="
export const CHECKBOX_TICK_ICON =
  "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTEiIGhlaWdodD0iNyIgdmlld0JveD0iMCAwIDExIDciIGZpbGw9Im5vbmUiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CjxwYXRoIGQ9Ik0xIDMuNDk5OThMMy4yOCA2TDEwIDEiIHN0cm9rZT0id2hpdGUiIHN0cm9rZS13aWR0aD0iMiIgc3Ryb2tlLWxpbmVjYXA9InJvdW5kIiBzdHJva2UtbGluZWpvaW49InJvdW5kIi8+Cjwvc3ZnPgo="
export default CONSTANTS
